import React from 'react'
// import { useTranslation} from 'react-i18next';

const NavMonth = (props) => {

    // const { t } = useTranslation();

	const aspireClick = (e) => {
      
        if(props.onClick)
            props.onClick(e);  
    }


    return (
        <div>
            <div className=" bg-dark">
				<div className="container">
					<div className="row justify-content-center">
						<button onClick={aspireClick} type="button" value="Tous"  className="text-white btn btn-dark text-decoration-none d-inline mr-1">Tous</button>
						<button onClick={aspireClick} type="button" value="Janvier" className="text-white btn btn-dark text-decoration-none d-inline mr-1">Janvier 2021</button>
						<button onClick={aspireClick} type="button" value="Fevrier" className="text-white btn btn-dark text-decoration-none d-inline mr-1">Fevrier 2021</button>
						<button onClick={aspireClick} type="button" value="Mars" className="text-white btn btn-dark text-decoration-none d-inline mr-1">Mars 2021</button>
						<button onClick={aspireClick} type="button" value="Avril" className="text-white btn btn-dark text-decoration-none d-inline mr-1">Avril 2021</button>
						<button onClick={aspireClick} type="button" value="Mai" className="text-white btn btn-dark text-decoration-none d-inline mr-1">Mai 2021</button>
					</div>	
				</div>
			</div>
        </div>
    )
}

export default NavMonth